<script>
	export let params

    import MainContainer from "./MainContainer.svelte"
	import ExperimentVariant from "./ExperimentVariant.svelte"
	import WeekDays from "./WeekDays.svelte"
    import MultiSelect from 'svelte-multiselect'

    import firebase from "firebase/app"
    import "firebase/firestore"
	import { getContext } from 'svelte'

    const userRole = getContext("userRole")

	let openedDocumendId = ""
	const experiment = {
		name: "",
		description: "",
		state: "active", //"disabled", "active", "paused"
		startTime: "",
		endTime: "",
		exposure: 0.5,
		locale: "",
		countries: "Any",
		newUsersOnly: false,
		otherUsers: true,
        organicUsers: true,
		asmrUsers: true,
		noAsmrUsers: true,
		useMinLevelRestriction: false,
		minStage: 0,
		minLevel: 0,
		useMaxLevelRestriction: false,
		maxStage: 0,
		maxLevel: 0,
		minAppVersion: "",
		users: 0, //update with cloud func
		activeDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
		platform: ["android"] // ["android", "ios", "windows"]
	}

	const defaultVariantNames = [
		"Control",
		... ["A", "B", "C", "D", "E", "F", "G"].map(e => `Variant ${e}`)
	]

    const countryList = [
        "Any", "Australia", "Austria", "Belarus", "Belgium", "Brazil", "Canada", "China", "Cuba", "Egypt", "Finland", "France", "Georgia", "Germany", "Greece",
        "Hungary", "India", "Indonesia", "Iran", "Iraq", "Italy", "Japan", "South Korea", "Malaysia", "Mexico", "Netherlands", "New Zealand", "Other",
        "Pakistan", "Philippines", "Poland", "Portugal", "Russia", "Spain", "Sweden", "Thailand", "Ukraine", "United Kingdom", "United States"
    ]
    let selectedCountries = ["Any"]

    $: variants = [
		{ id: "Baseline", name: "Control", users: 0, state: "active", params: [{name: "", value: ""}] }
	]

    if (params.id !== "-1") {
        const doc = firebase.firestore().collection("Experiments").doc(params.id)
		doc.get().then(snapshot => {
			if (snapshot.exists) {
				openedDocumendId = snapshot.id
				const data = snapshot.data()
				// Object.assign(experiment, data) does not work with binding
				for (let key in data) {
					experiment[key] = data[key]
				}
				if (data.startTime) {
					document.getElementById('startTime').value = dateToString(data.startTime.toDate())
				}
				if (data.endTime) {
					document.getElementById('endTime').value = dateToString(data.endTime.toDate())
				}
                selectedCountries = experiment.countries === '' ? [] : experiment.countries.split(',')

				return snapshot
			} else {
				throw new Error("Document not found")
			}
		}).then(() => {
			const variantsCollection = firebase.firestore().collection(`Experiments/${params.id}/Configs`)
			return variantsCollection.get().then(querySnapshot => {
				const variantsFromServer = []
				querySnapshot.forEach(doc => {
					const variant = doc.data()
					variant.params.forEach(e => {
						if (e.name !== "experimentTournamentType")
							e.value = JSON.stringify(e.value)
					})
					//last unconfigured param (to add new)
					variant.params.push({name: "", value: ""})
					variantsFromServer.push(variant)
				})
				variants = [...variantsFromServer]
			})
		}).then(() => M.updateTextFields())
	}

	function addVariant() {
		if (variants.length === defaultVariantNames.length) return

		for (let i = 1; i < defaultVariantNames.length; i++) {
			const name = defaultVariantNames[i]
			const id = name.replace(' ', '')
			if (variants.some(e => e.id === id)) continue
			
			variants = [...variants, { id, name, users: 0, state: "active", params: [{name: "", value: ""}] }]
			return
		}
	}

	async function createExperiment() {
		const errors = checkErrors(experiment, variants)
		if (errors.length > 0) {
			errors.forEach(e => M.toast({ html: `<i class="material-icons left">warning</i>${e}` }))
			return
		} 

		fixSomeExperimentValues()

		const openedDocument = await firebase.firestore().collection("Experiments").add(experiment)
		openedDocumendId = openedDocument.id
		updateVariants().then(() => window.location.href = "/#/Experiments")
	}

	async function enableExperiment() {
		firebase.firestore()
			.collection("Experiments")
			.doc(openedDocumendId)
			.update({ state: "active", endTime: "" })
			.then(() => window.location.href = "/#/Experiments")
	}

	async function disableExperiment() {
        const now = new Date()
        now.setUTCHours(0, 0, 0, 0)
        experiment.endTime = firebase.firestore.Timestamp.fromDate(now)
        document.getElementById('endTime').value = dateToString(now)

		firebase.firestore()
			.collection("Experiments")
			.doc(openedDocumendId)
			.update({ state: "disabled", endTime: experiment.endTime })
			.then(() => window.location.href = "/#/Experiments")
	}

	async function deleteExperiment() {
		firebase.firestore()
			.collection("Experiments")
			.doc(openedDocumendId)
			.delete()
			.then(deleteVariants)
			.then(() => window.location.href = "/#/Experiments")
	}

	function updateExperiment() {
		const errors = checkErrors(experiment, variants)
		if (errors.length > 0) {
			errors.forEach(e => M.toast({ html: `<i class="material-icons left">warning</i>${e}` }))
			return
		} 

		fixSomeExperimentValues()

		firebase.firestore()
			.collection("Experiments")
			.doc(openedDocumendId)
			.update(experiment)
			.then(updateVariants)
			.then(() => window.location.href = "/#/Experiments")
	}

	function fixSomeExperimentValues() {
		if (!experiment.minAppVersion) {
			experiment.minAppVersion = '0.0.1'
		}

		experiment.name = experiment.name.replaceAll('\\', '/')
		experiment.description = experiment.description.replaceAll('\\', '/')

		experiment.countries = selectedCountries.join()
	
		updateExperimentPlatform()
	}

	function updateVariants() {
		return deleteVariants().then(createVariants)
	}

	function deleteVariants() {
		if (openedDocumendId) {
			const collection = firebase.firestore().collection(`Experiments/${openedDocumendId}/Configs`)
			return collection.get().then(querySnapshot => {
				return Promise.all(querySnapshot.docs.map(doc => firebase.firestore().doc(`Experiments/${openedDocumendId}/Configs/${doc.id}`).delete()))
			})
		}

		return Promise.reject()
	}

	function createVariants() {
		if (openedDocumendId) {
			const collection = firebase.firestore().collection(`Experiments/${openedDocumendId}/Configs`)
			variants.forEach(variant => {
				variant.params = variant.params.filter(e => e.name && e.value)
				variant.params = variant.params.map(e => {
					if (e.value.match("^\\[(\\d+,)*\\d+\\]$")) {
						e.value = e.value.slice(1, e.value.length - 1).split(',').map(p => Number(p))
					} else if (e.value.match("^(true|false)$")) {
						e.value = Boolean(e.value === "true")
					} else if (e.value.startsWith('"')) {
						e.value = e.value.slice(1, e.value.length - 1)
					} else if (e.name === "experimentTournamentType") {
						e.value = e.value
					} else {
						e.value = Number(e.value)
					}
					return e
				})
			})
			return Promise.all(variants.map(v => collection.doc(v.id).set(v)))
		}

		return Promise.reject()
	}

	function startTimeChanged() {
		const value = document.getElementById('startTime').value
		experiment.startTime = firebase.firestore.Timestamp.fromDate(stringToDate(value))
	}

	function setupStartTimePicker() {
		if (experiment.startTime) {
			const instance = M.Datepicker.getInstance(document.getElementById('startTime'))
			instance.setDate(experiment.startTime.toDate())
		}
	}

	function endTimeChanged() {
		const value = document.getElementById('endTime').value
		experiment.endTime = value ? firebase.firestore.Timestamp.fromDate(stringToDate(value)) : ""
	}

	function setupEndTimePicker() {
		if (experiment.endTime) {
			const instance = M.Datepicker.getInstance(document.getElementById('endTime'))
			instance.setDate(experiment.endTime.toDate())
		}
	}

	function removeVariant(index) {
		if (variants.length === 1) {
			return
		}

		variants = variants.filter((e, i) => i !== index);
	}

	function setupDefaults() {
		if (!experiment.startTime) {
			const now = new Date()
			now.setUTCHours(0, 0, 0, 0)
			experiment.startTime = firebase.firestore.Timestamp.fromDate(now)
			document.getElementById('startTime').value = dateToString(now)
		}

		M.updateTextFields()
	}

	function dateToString(date) {
		return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
	}

	function stringToDate(dateString) {
		const date = new Date(dateString)
		const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0 ))
		return utcDate
	}

	function checkErrors(experiment, variants) {
		const errors = []

		if (!experiment.name) {
			errors.push('Name is not specified')
		}

		if (!experiment.startTime) {
			errors.push('Start date is not specified')
		}

		if (experiment.startTime && experiment.endTime && experiment.startTime > experiment.endTime) {
			errors.push('Start date is greater than end date')
		}

		if (!experiment.otherUsers && !experiment.organicUsers && !experiment.asmrUsers && !experiment.noAsmrUsers) {
			errors.push('One users\' checkbox must be checked at least')
		}

		if (variants.length < 2) {
			errors.push('Experiment must have two configurations at least')
		}

		//check params
		const paramsValid = variants.every(v => {
			let hasNonEmptyParameters = false
			const validParameters = v.params.every((param, index) => {
				const idOnPage=`${v.id}__${index}`
				const cond = param.value != "" && document.getElementById(`${idOnPage}__Value`).reportValidity()
				//console.log(`+ name: ${param.name}, value: ${param.value}, cond: ${cond}`)

				if (param.name == "") 
					return true
				else {
					hasNonEmptyParameters = true
					if (!cond) 
						errors.push(`Parameter '${param.name}' was not validated`)		
					return cond
				}
			})
			
			if (!hasNonEmptyParameters) {
				errors.push(`${v.name} must have at least one non-empty parameter`)
			}
			return hasNonEmptyParameters && validParameters
		})

		return errors
	}

    function onCountriesChanged(event) {
        if (selectedCountries.includes('Any')) {
           selectedCountries = ['Any']
        }
    }

	function updateExperimentPlatform() {
		let platform = []
		if (document.getElementById('platformAndroid').checked)
			platform.push("android")
		if (document.getElementById('platformIos').checked)
			platform.push("ios")
		if (document.getElementById('platformWindows').checked)
			platform.push("windows")
		experiment.platform = platform
	}

	import {afterUpdate} from 'svelte'
	afterUpdate(async () => {
		const pickers = document.querySelectorAll('.datepicker')
		M.Datepicker.init(pickers)

		const selects = document.querySelectorAll('select')
		M.FormSelect.init(selects)

		const collaps = document.querySelectorAll('.collapsible')
		M.Collapsible.init(collaps)

		const modals = document.querySelectorAll('.modal')
        M.Modal.init(modals, { dismissible: false })

		setupDefaults()
	})
</script>


<MainContainer>
	<h5 class="blue-text"><i class="material-icons left">label_important</i>Experiment: {openedDocumendId}</h5>
	<ul class="collapsible">
		<li>
			<div class="collapsible-header"><i class="material-icons">create</i>Basics</div>
			<div class="collapsible-body">
				<form>
					<div class="row">
						<div class="input-field col s5">
							<input id="name" type="text" class="validate" required bind:value="{experiment.name}">
							<label for="name">Name</label>
						</div>
						<div class="input-field col s7">
							<input id="description" type="text" class="validate" bind:value="{experiment.description}">
							<label for="description">Description</label>
						</div>
					</div>
					<div class="row">
						<div class="input-field col s5">
							<input id="startTime" type="text" class="datepicker" on:change="{startTimeChanged}" on:click="{setupStartTimePicker}">
							<label for="startTime">Start date</label>
						</div>
						<div class="input-field col s5">
						 	<input id="endTime" type="text" class="datepicker" on:change="{endTimeChanged}" on:click="{setupEndTimePicker}">
						 	<label for="endTime">End date</label>
						</div>
					</div>
				</form>
				<WeekDays bind:activeDays={experiment.activeDays} editable=true/>
			</div>
		</li>
		<li>
			<div class="collapsible-header"><i class="material-icons">group</i>Targeting</div>
			<div class="collapsible-body">
				<form>
                    <div class="row">
                        <!--p style="word-wrap: break-word; word-break: break-word;">Selected countries = {JSON.stringify(selectedCountries)}</p-->
                        <MultiSelect bind:selected={selectedCountries} options={countryList} placeholder={'Choose countries'} sortSelected={true} 
                            on:change={(event) => onCountriesChanged(event)}
                        />
                    </div>
					<div class="row">
						<div class="input-field col s4">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.useMinLevelRestriction}/>
								<span>Use min level restriction</span>
							</label>
						</div>
						{#if experiment.useMinLevelRestriction}
                            <div class="input-field col s3">
                                <input id="minStage" type="number" class="validate" bind:value={experiment.minStage}>
                                <label for="minStage">Min stage (count from 1)</label>
                            </div>
                            <div class="input-field col s2">
                                <input id="minLevel" type="number" class="validate" bind:value={experiment.minLevel}>
                                <label for="minLevel">Min level</label>
                            </div>
						{/if}
					</div>
					<div class="row">
						<div class="input-field col s4">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.useMaxLevelRestriction}/>
								<span>Use max level restriction</span>
							</label>
						</div>
						{#if experiment.useMaxLevelRestriction}
                            <div class="input-field col s3">
                                <input id="maxStage" type="number" class="validate" bind:value={experiment.maxStage}>
                                <label for="maxStage">Max stage (count from 1)</label>
                            </div>
                            <div class="input-field col s2">
                                <input id="maxLevel" type="number" class="validate" bind:value={experiment.maxLevel}>
                                <label for="maxLevel">Max level</label>
                            </div>
						{/if}
					</div>
					<br>
					<div class="row">
						<div class="input-field col s3">
							<label>
								<input id="platformAndroid" type="checkbox" class="filled-in" checked={experiment.platform.includes("android")} />
								<span>Android</span>
							</label>
						</div>
						<div class="input-field col s3">
							<label>
								<input id="platformIos" type="checkbox" class="filled-in" checked={experiment.platform.includes("ios")} />
								<span>iOs</span>
							</label>
						</div>
						<div class="input-field col s3">
							<label>
								<input id="platformWindows" type="checkbox" class="filled-in" checked={experiment.platform.includes("windows")} />
								<span>Windows</span>
							</label>
						</div>
					</div>
					<br><br>
					<div class="row">
						<div class="input-field col s2">
							<input id="minAppVersion" type="text" class="validate" bind:value={experiment.minAppVersion}>
							<label for="minAppVersion">Min app version</label>
						</div>
						<div class="input-field col s3">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.newUsersOnly}/>
								<span>New users only</span>
							</label>
						</div>
					</div>	
					<div class="row">
						<div class="col s2">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.otherUsers}/>
								<span>Other users</span>
							</label>
						</div>	
						<div class="col s2">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.organicUsers}/>
								<span>Organic users</span>
							</label>
						</div>	
						<div class="col s2">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.asmrUsers}/>
								<span>ASMR users</span>
							</label>
						</div>
						<div class="col s2">
							<label>
								<input type="checkbox" class="filled-in" bind:checked={experiment.noAsmrUsers}/>
								<span>NOASMR users</span>
							</label>
						</div>
					</div>
					<div class="row">
						<div class="col s4">
							<input id="exposure" type="range" min="0" max="1" bind:value={experiment.exposure} step={0.05} />
							<label for="exposure">Exposure</label>
						</div>
						<div class="col s2">
							{Math.round(experiment.exposure * 100)}%
						</div>
					</div>
				</form>
			</div>
		</li>
		<li>
			<div class="collapsible-header"><i class="material-icons">call_split</i>Variants</div>
			<div class="collapsible-body">
				{#each variants as variant, index (variant.id)}
					<ExperimentVariant bind:variant={variant} on:remove={() => removeVariant(index)}/>
				{/each}
				<div class="row">
					<button on:click={ () => addVariant() } class="col s4 offset-s4 waves-effect waves-light btn">
						<i class="material-icons left">add_circle</i>
						Add another variant
					</button>
				</div>
			</div>
		</li>
	</ul>
	{#if userRole === "Writer"}
		<div class="row">
			{#if !openedDocumendId}
				<button on:click={ () => createExperiment() } class="col s4 offset-s4 waves-effect waves-light btn">
					Create
				</button>
			{:else}
				<button on:click={ () => updateExperiment() } class="col s2 offset-s2 waves-effect waves-light btn">
					Update
				</button>
				{#if experiment.state === "disabled"}
					<button on:click={ () => enableExperiment() } class="col s2 offset-s1 waves-effect waves-light yellow darken-3 btn">
						Enable
					</button>
				{:else}
					<button on:click={ () => disableExperiment() } class="col s2 offset-s1 waves-effect waves-light yellow darken-3 btn">
						Disable
					</button>
				{/if}
				<button data-target="deletion-modal" class="col s2 offset-s1 waves-effect waves-light deep-orange darken-4 btn modal-trigger">
					Delete
				</button>
			{/if}
		</div>
	{/if}
	<div id="deletion-modal" class="modal">
		<div class="modal-content">
			<h4>Delete experiment</h4>
			<p>Are you sure you want to delete the experiment?</p>
		</div>
		<div class="modal-footer">
			<button class="modal-close waves-effect waves-green btn-flat" on:click={ () => deleteExperiment() }>
				Yes
			</button>
			<button class="modal-close waves-effect waves-green btn-flat">
				No
			</button>
		</div>
	</div>
</MainContainer>

<style>
    :global(div.multiselect) {
        margin: 0 0;
    }
</style>
